module.exports = __webpack_public_path__ + "static/media/readme.46e1e8e9.svg";